"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: client-proxy/family.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fclient-proxy%2Ffamily.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.Family = void 0;
const address_1 = require("../common/address");
const family_invite_info_1 = require("../user/family-invite-info");
const family_member_1 = require("../user/family-member");
const protobufPackage = 'com.step.clientproxy.proto';
function createBaseFamily() {
    return { members: [], invitesSent: [], invitesReceived: [], address: undefined };
}
exports.Family = {
    fromJSON(object) {
        const message = {
            members: globalThis.Array.isArray(object?.members)
                ? object.members.map((e) => family_member_1.FamilyMember.fromJSON(e))
                : [],
            invitesSent: globalThis.Array.isArray(object?.invitesSent)
                ? object.invitesSent.map((e) => family_invite_info_1.FamilyInviteInfo.fromJSON(e))
                : [],
            invitesReceived: globalThis.Array.isArray(object?.invitesReceived)
                ? object.invitesReceived.map((e) => family_invite_info_1.ReceivedInvite.fromJSON(e))
                : [],
        };
        if (isSet(object.address)) {
            message.address = address_1.Address.fromJSON(object.address);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.members?.length) {
            obj.members = message.members.map((e) => family_member_1.FamilyMember.toJSON(e));
        }
        if (message.invitesSent?.length) {
            obj.invitesSent = message.invitesSent.map((e) => family_invite_info_1.FamilyInviteInfo.toJSON(e));
        }
        if (message.invitesReceived?.length) {
            obj.invitesReceived = message.invitesReceived.map((e) => family_invite_info_1.ReceivedInvite.toJSON(e));
        }
        if (message.address !== undefined) {
            obj.address = address_1.Address.toJSON(message.address);
        }
        return obj;
    },
    create(base) {
        return exports.Family.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFamily();
        message.members = object.members?.map((e) => family_member_1.FamilyMember.fromPartial(e)) || [];
        message.invitesSent = object.invitesSent?.map((e) => family_invite_info_1.FamilyInviteInfo.fromPartial(e)) || [];
        message.invitesReceived = object.invitesReceived?.map((e) => family_invite_info_1.ReceivedInvite.fromPartial(e)) ||
            [];
        message.address = (object.address !== undefined && object.address !== null)
            ? address_1.Address.fromPartial(object.address)
            : undefined;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=family.js.map